import Vue from 'vue'
import uuid from 'node-uuid'
import axios from 'axios'
import router from '@/router'

const state = {
  name: null,
  id: null,
  pictureSrc: null,
  isCreating: false,
};

const mutations = {
  setName: (state, payload) => {
    state.name = payload.name
  },
  setId: (state, payload) => {
    state.id = payload.id
  },
  setPictureSrc: (state, payload) => {
    state.pictureSrc = payload.pictureSrc
  },
  setIsCreating: (state, payload) => {
    state.isCreating = payload.isCreating
  }
};

const actions = {
  signup: async ({commit, state}, payload) => {
    commit('setIsCreating', {isCreating: true})
    commit('setName', payload)
    commit('setId', { id: uuid.v4() })
    const res = await axios.get('https://picsum.photos/80/80/?random', { 'responseType': 'arraybuffer' })
    const base64 = new Buffer(res.data, "binary").toString("base64")
    const prefix = `data:${res.headers["content-type"]};base64,`
    commit('setPictureSrc', { pictureSrc: `${prefix}${base64}` })
    localStorage["id"] = state.id
    localStorage["userName"] = state.name
    localStorage["pictureSrc"] = state.pictureSrc
    commit('setIsCreating', {isCreating: false})
    router.push('rooms')
  },
};

const getters = {
  currentName: state => {
    return state.name;
  },
  currentAccount: state => {
    return { id: state.id, name: state.name, pictureSrc: state.pictureSrc }
  },
  currentIsCreating: state => {
    return state.isCreating;
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js